module.exports = __webpack_public_path__ + "img/mx.6ee1e6d4.svg";